 import icLogout from '../assets/icLogout.svg';
 import icLogo from '../assets/icLogo.png';
 import imageBg from '../assets/imageBG.jpeg';
 
 const assets = {
  icLogout,
  icLogo,
  imageBg
}

export default assets;
